<template>
	<el-container>
		<Header></Header>
		<el-container class="wrap-80" style="margin: 20px auto">
			<div class="user-center flex">
				<Aside title="企业中心"></Aside>
				<router-view key="mainbox" style="flex: 1"></router-view>
			</div> </el-container
	></el-container>
</template>

<script>
import Aside from './components/Aside.vue';
import Header from './components/Header.vue';
import BreadCrumb from '@/components/Breadcrumb/index.vue';

export default {
	name: 'UserCenterIndex',
	components: {
		BreadCrumb,
		Aside,
		Header
	},
};
</script>

<style lang="less" scoped>
.layout {
	height: 100%;
	width: 100%;
	overflow: hidden;
	display: flex;
	position: relative;
	.container_right {
		display: flex;
		flex-direction: column;
	}
	// .vue-particles {
	//   position: absolute;
	//   top: 0;
	//   left: 0;
	//   width: 100%;
	//   height: 100%;
	//   // background: url(~@/assets/bac.png);
	//   // background-size: cover;

	// }
}

@media screen and (max-width: 767px) {
  .user-center.flex { flex-direction: column; }
  .user-center .leftbox { width: 100% !important; margin-bottom: 12px; }
  .user-center > [style*="flex: 1"] { width: 100%; }
}
</style>
